import CardImage from './CardImage';

const PROMOTED_PLACEHOLDER_SRC = '/static/images/placeholder/promoted.svg';

type CardPlaceholderProps = {
  loading?: 'eager' | 'lazy';
  fetchPriority?: 'high' | 'low';
};

export const CardPlaceholder = ({ loading = 'lazy', fetchPriority }: CardPlaceholderProps) => (
  <CardImage
    src={PROMOTED_PLACEHOLDER_SRC}
    alt=""
    aria-hidden="true"
    loading={loading}
    {...(fetchPriority ? ({ fetchpriority: fetchPriority } as any) : {})}
  />
);
